import styled, { css } from 'styled-components';
import { Flex, FlexProps } from '@mantine/core';

const VIRTUALIZER_LIST_MARGIN_BOTTOM = '1rem';

export const PersonCardStyledPin = styled.div<{ $isActive?: boolean }>`
	display: flex;
	visibility: hidden;
	opacity: 0;
	transition:
		visibility 0s,
		opacity 0.3s ease;
	padding: 0.25rem;
	border-radius: 50%;
	justify-content: center;
	align-items: center;
	font-weight: normal;
	background-color: white;

	&:hover {
		cursor: pointer;
	}

	${({ $isActive }) =>
		$isActive &&
		css`
			font-weight: bold;
			visibility: visible;
			opacity: 1;
		`}
`;

export const StyledPersonCard = styled.div<{ $isSelected?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding: 0.5rem;
	width: 100%;
	position: relative;
	border: 1px solid transparent;
	border-radius: 0.25rem;
	transition: background-color 0.2s ease-out;

	&:hover {
		cursor: pointer;

		${PersonCardStyledPin} {
			visibility: visible;
			opacity: 1;
		}
	}

	${({ $isSelected }) =>
		$isSelected
			? css`
					background-color: ${({ theme }) => theme.v3.colors.blue[0]};
					border-color: ${({ theme }) => theme.v3.colors.blue[6]};

					&:hover {
						cursor: default;
						box-shadow: none;
					}
				`
			: css`
					&:hover {
						background-color: ${({ theme }) => theme.v3.colors.gray[0]};
					}
				`}
`;

export const StyledProfileIcon = styled(Flex)<FlexProps>`
	border-radius: 1rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	padding: 0.3rem 0.45rem;
	width: auto;
	margin-top: 0.5rem;
`;

export const StyledVirtualizedListContainer = styled.div`
	::-webkit-scrollbar {
		width: 0;
		height: 0;
	}

	margin-bottom: ${VIRTUALIZER_LIST_MARGIN_BOTTOM};
`;

export const StyledLoadMoreContainer = styled(Flex)<FlexProps>`
	position: absolute;
	align-items: center;
	justify-content: center;
	z-index: 2;
	height: 56px;
	bottom: ${VIRTUALIZER_LIST_MARGIN_BOTTOM};
	width: 100%;
	background: linear-gradient(0deg, white 0%, rgba(255, 255, 255, 0) 100%);
`;
